import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CalendarDays, BookOpen } from "lucide-react";
import { AnimatedProgress, itemV } from "./motion";
import { Badge } from "./common";
import { fmtDate } from "../lib/api";

export default function CourseCard({ c }) {
  return (
    <motion.div variants={itemV} style={{ perspective: 1000 }}>
      <Link to={`/panel/egitimlerim/${c.id}`} data-testid={`course-card-${c.id}`} className="group surface lift flex h-full flex-col overflow-hidden">
        <div className="relative aspect-[16/9] overflow-hidden bg-slate-100">
          {c.cover_url ? (
            <img src={c.cover_url} alt={c.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />
          ) : (
            <div className="grid h-full place-items-center text-slate-300"><BookOpen className="h-10 w-10" /></div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent" />
          <div className="absolute left-3 top-3 flex gap-1.5">
            <Badge status={c.state} />
            {c.is_demo && <Badge status="demo" />}
          </div>
        </div>
        <div className="flex flex-1 flex-col p-5">
          <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400">{c.category || "Eğitim"}</p>
          <h3 className="mt-1.5 text-[17px] font-bold leading-snug text-[var(--ink)]" data-testid="course-card-title">{c.title}</h3>
          <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" /> {fmtDate(c.start_date)}</span>
            <span>→ {fmtDate(c.end_date)}</span>
          </div>
          <div className="mt-auto pt-5">
            <div className="mb-2 flex items-center justify-between text-xs font-semibold">
              <span className="text-slate-500">İlerleme</span>
              <span className="text-[var(--ink)]" data-testid="course-card-progress">%{c.progress}</span>
            </div>
            <AnimatedProgress value={c.progress} />
            <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--brand)]">
              {c.progress === 100 ? "Eğitimi İncele" : "Eğitime Git"}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
